import { HSLA, HSVA, RGBA } from '@ctrl/tinycolor'
import React from 'react'
import { ColorPickerAlpha } from 'src/editor/shared/ui-lib/color-picker/color-picker-hsl-ui/color-picker-alpha'
import { ColorPickerHue } from 'src/editor/shared/ui-lib/color-picker/color-picker-hsl-ui/color-picker-hue'
import { ColorPickerSaturation } from 'src/editor/shared/ui-lib/color-picker/color-picker-hsl-ui/color-picker-saturation'
import { ReactColorChangeResult } from 'src/shared/types/color-typings'

export interface ColorPickerHslProps {
  rgba: RGBA
  hsl: HSLA
  hsv: HSVA
  handleColorChange: (colorResult: ReactColorChangeResult) => void
  handleOpacityChange: (opacity: number) => void
}

export const ColorPickerHsl = ({
  rgba,
  hsl,
  hsv,
  handleColorChange,
  handleOpacityChange,
}: ColorPickerHslProps) => {
  return (
    <React.Fragment>
      <ColorPickerSaturation hsl={hsl} hsv={hsv} onChange={handleColorChange} />
      <div className="mt-4 flex flex-col gap-3">
        <ColorPickerHue hsl={hsl} onChange={handleColorChange} />
        <ColorPickerAlpha rgb={rgba} onChange={handleOpacityChange} />
      </div>
    </React.Fragment>
  )
}
